document.addEventListener("DOMContentLoaded", () => {
  const openWishlistModal = document.getElementById("openWishlistModal");
  const wishlistModal = document.getElementById("wishlist-modal");
  const closeButtons = wishlistModal.querySelectorAll(
    '[is="dialog-close-button"]'
  );
  const body = document.body;
  let scrollY = 0;

  if (openWishlistModal && wishlistModal) {
    // モーダル開く
    openWishlistModal.addEventListener("click", () => {
      scrollY = window.scrollY;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.classList.add("wishlist-modal-open");
      wishlistModal.classList.add("active");
    });

    // 背景クリックで閉じる
    wishlistModal.addEventListener("click", (event) => {
      if (event.target === wishlistModal) {
        closeDrawer();
      }
    });

    // 閉じるボタン
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener("click", closeDrawer);
    });

    // モーダルを閉じる
    function closeDrawer() {
      wishlistModal.classList.remove("active");
      body.classList.remove("wishlist-modal-open");
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      window.scrollTo(0, scrollY);
    }
  }
});
